import {
  InputLabel,
  FormControl,
  Autocomplete,
  TextField,
  AutocompletePropsSizeOverrides,
  Theme,
  FormHelperText,
} from '@mui/material'
import React from 'react'
import { OverridableStringUnion } from '@mui/types'
import { SxProps } from '@mui/system'
import { State } from '@hookstate/core'
import { useLang } from '~/hooks/useLang'

export interface OptionType {
  readonly id: number | string
  readonly name: string
}

interface ISelectBasic {
  readonly state: State<string | null>
  readonly isInvalidRequest?: boolean
  readonly placeholder: string
  readonly options: ReadonlyArray<OptionType | null>
  readonly disabled?: boolean
  readonly required?: boolean
  readonly defaultValue?: string
  readonly size?: OverridableStringUnion<
    'small' | 'medium',
    AutocompletePropsSizeOverrides
  >
  readonly sx?: SxProps<Theme>
  readonly handleChange?: (value: OptionType | null) => void
  readonly error?: State<string | null | undefined>
}

export default function SelectBasic({
  state,
  placeholder,
  options,
  required = false,
  disabled = false,
  size = 'medium',
  defaultValue,
  sx,
  isInvalidRequest = false,
  handleChange,
  error,
}: ISelectBasic) {
  const { translate } = useLang()
  const errorLocal = error

  // Busca o objeto da opção selecionada pelo id salvo no estado
  const selectedOption =
    options.find((opt) => opt && String(opt.id) === String(state.get())) || null

  const localHandleChange = (
    _: React.SyntheticEvent,
    value: OptionType | null
  ) => {
    state.set(value ? String(value.id) : '')
    errorLocal?.set('')
    handleChange?.(value)
  }

  return (
    <FormControl
      required={required}
      error={!!error?.get()}
      disabled={disabled}
      sx={sx}
      size={size}
      fullWidth
    >
      <Autocomplete
        options={options.filter(Boolean) as readonly OptionType[]}
        getOptionLabel={(option) => translate(option.name)}
        value={selectedOption}
        onChange={localHandleChange}
        isOptionEqualToValue={(option, value) =>
          String(option.id) === String(value.id)
        }
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label={placeholder}
            required={required}
            error={!!error?.get()}
            helperText={translate(errorLocal?.get() ?? '')}
            size={size}
          />
        )}
        size={size}
      />
    </FormControl>
  )
}
